module.exports = __webpack_public_path__ + "img/konbini-logo-vector.8043d7bc.svg";